function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { withSnackbar } from "notistack";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { ADDRESS_INPUT, ANIMATION_TIMEOUT, CITY_INPUT, COUNTRY_DROPDOWN, DROPDOWN_KEYBOARD_SEARCH_TIMEOUT, FIRST_NAME_INPUT, GDPR_BILLING_CHECKBOX, GDPR_SHIPPING_CHECKBOX, KEY_ARROW_DOWN, KEY_ARROW_UP, LAST_NAME_INPUT, PHONE_INPUT, REGEX_ADDRESS, REGEX_ALPHABET, REGEX_ALPHANUMERIC, REGEX_PHONE, SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR, SNACKBAR_VARIANT_SUCCESS, STATUS_CODE_SUCCESS, ZIP_INPUT } from "@config/constants";
import { COUNTRIES } from "@config/countries";
import { openGdpr } from "@common/actions/modals";
import { editBillingDetails, getFullUserDetails } from "@common/actions/user-details";
import { replaceWith } from "@common/services/helpers";
var EditUserAddress = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(EditUserAddress, PureComponent);
    var _super = _create_super(EditUserAddress);
    function EditUserAddress(props) {
        _class_call_check(this, EditUserAddress);
        var _this;
        _this = _super.call(this, props);
        var address = props.address, isDeliveryAddressForm = props.isDeliveryAddressForm, userDetails = props.userDetails;
        _this.state = {
            firstName: (address === null || address === void 0 ? void 0 : address.firstName) || "",
            firstNameError: "",
            lastName: (address === null || address === void 0 ? void 0 : address.lastName) || "",
            lastNameError: "",
            phone: (address === null || address === void 0 ? void 0 : address.phone) || "",
            phoneError: "",
            city: (address === null || address === void 0 ? void 0 : address.city) || "",
            cityError: "",
            zip: (address === null || address === void 0 ? void 0 : address.zip) || "",
            zipError: "",
            address: (address === null || address === void 0 ? void 0 : address.address) || "",
            addressError: "",
            country: (address === null || address === void 0 ? void 0 : address.countryName) || userDetails.predefinedCountry,
            countryCode: (address === null || address === void 0 ? void 0 : address.country) || userDetails.predefinedCountryCode,
            countryError: "",
            gdprBilling: address === null || address === void 0 ? void 0 : address.gdprBilling,
            gdprBillingError: false,
            gdprShipping: address === null || address === void 0 ? void 0 : address.gdprShipping,
            gdprShippingError: false,
            sameAddress: isDeliveryAddressForm ? true : address === null || address === void 0 ? void 0 : address.sameAddress,
            isComponentMounted: false,
            willComponentUnmount: false,
            globalFormError: "",
            searchLastLetter: ""
        };
        _this._isMounted = false;
        _this.timeout = null;
        _this.animationTimeout = null;
        _this.activeIndex = 0;
        _this.dropdownSearchQuery = "";
        _this.gdprShippingButton = null;
        _this.gdprBillingButton = null;
        _this.dropdown = null;
        _this.renderInput = _this.renderInput.bind(_assert_this_initialized(_this));
        _this.setGdprButtonRef = _this.setGdprButtonRef.bind(_assert_this_initialized(_this));
        _this.renderCountriesDropdown = _this.renderCountriesDropdown.bind(_assert_this_initialized(_this));
        _this.renderGDPRCheckbox = _this.renderGDPRCheckbox.bind(_assert_this_initialized(_this));
        _this.changeInputValue = _this.changeInputValue.bind(_assert_this_initialized(_this));
        _this.changeCountry = _this.changeCountry.bind(_assert_this_initialized(_this));
        _this.validateInput = _this.validateInput.bind(_assert_this_initialized(_this));
        _this.validateCheckbox = _this.validateCheckbox.bind(_assert_this_initialized(_this));
        _this.removeHoverClass = _this.removeHoverClass.bind(_assert_this_initialized(_this));
        _this.submitForm = _this.submitForm.bind(_assert_this_initialized(_this));
        _this.validateForm = _this.validateForm.bind(_assert_this_initialized(_this));
        _this.openGdprPopup = _this.openGdprPopup.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(EditUserAddress, [
        {
            /**
   * Validates form before submit
   */ key: "validateForm",
            value: function validateForm() {
                var _this_props = this.props, isDeliveryAddressForm = _this_props.isDeliveryAddressForm, setFormValidity = _this_props.setFormValidity, isEditDeliveryOpen = _this_props.isEditDeliveryOpen, isEditBillingOpen = _this_props.isEditBillingOpen;
                var fields = [
                    FIRST_NAME_INPUT,
                    LAST_NAME_INPUT,
                    PHONE_INPUT,
                    COUNTRY_DROPDOWN,
                    ZIP_INPUT,
                    ADDRESS_INPUT,
                    CITY_INPUT
                ];
                var GDPRField = isDeliveryAddressForm ? GDPR_SHIPPING_CHECKBOX : GDPR_BILLING_CHECKBOX;
                var isValid = true;
                if (!isEditDeliveryOpen) {
                    setFormValidity(true, true);
                }
                if (!isEditBillingOpen) {
                    setFormValidity(false, true);
                }
                for(var index = 0; index < fields.length; index++){
                    if (!this.validateInput(fields[index])) {
                        isValid = false;
                    }
                }
                if (!this.state[GDPRField]) {
                    isValid = false;
                    this.setState(_define_property({}, "".concat(GDPRField, "Error"), true));
                }
                setFormValidity(isDeliveryAddressForm, isValid);
            }
        },
        {
            key: "submitForm",
            value: /**
   * Method responsible for the forms submission.
   * Both forms are submitted simultaneously, this the data is constructed for the 2 different calls
   */ function submitForm() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_state, firstName, lastName, city, zip, address, countryCode, gdprShipping, gdprBilling, token, _this_props, _$editBillingDetails, isDeliveryAddressForm, i18n, sameAddress, enqueueSnackbar, data, phone, addressInfo, response, e, error, fieldError, startIndex, endIndex, key, errorKey;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.props.userLoading.length === 0)) return [
                                    3,
                                    8
                                ];
                                _this_state = _this.state, firstName = _this_state.firstName, lastName = _this_state.lastName, city = _this_state.city, zip = _this_state.zip, address = _this_state.address, countryCode = _this_state.countryCode, gdprShipping = _this_state.gdprShipping, gdprBilling = _this_state.gdprBilling;
                                token = _this.props.authentication.token;
                                _this_props = _this.props, _$editBillingDetails = _this_props.editBillingDetails, isDeliveryAddressForm = _this_props.isDeliveryAddressForm, i18n = _this_props.i18n, sameAddress = _this_props.sameAddress, enqueueSnackbar = _this_props.enqueueSnackbar;
                                data = {
                                    token: token,
                                    sameAddress: sameAddress
                                };
                                phone = _this.state.phone.replace(/\s/g, "");
                                addressInfo = {
                                    firstName: firstName,
                                    lastName: lastName,
                                    zip: zip,
                                    address: address,
                                    city: city,
                                    phone: phone,
                                    country: countryCode
                                };
                                if (isDeliveryAddressForm) {
                                    data.subscription = {
                                        shippingAddress: _object_spread_props(_object_spread({}, addressInfo), {
                                            gdprShipping: gdprShipping
                                        })
                                    };
                                } else {
                                    data.billingAddress = _object_spread_props(_object_spread({}, addressInfo), {
                                        gdprBilling: gdprBilling
                                    });
                                    if (sameAddress) {
                                        data.subscription = {
                                            shippingAddress: _object_spread_props(_object_spread({}, addressInfo), {
                                                gdprShipping: true
                                            })
                                        };
                                    }
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    ,
                                    8
                                ]);
                                _this.props.setUserLoad(true);
                                return [
                                    4,
                                    _$editBillingDetails(data)
                                ];
                            case 2:
                                response = _state.sent();
                                if (!(response.status === STATUS_CODE_SUCCESS)) return [
                                    3,
                                    6
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this.props.getFullUserDetails()
                                ];
                            case 4:
                                _state.sent();
                                _this.props.callbackOnSuccessfulAddressChange(isDeliveryAddressForm);
                                _this.setState({
                                    globalFormError: ""
                                });
                                isDeliveryAddressForm ? enqueueSnackbar(i18n.snackbar.deliveryAddressEditSuccess, {
                                    variant: SNACKBAR_VARIANT_SUCCESS,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                }) : enqueueSnackbar(i18n.snackbar.billingAddressEditSuccess, {
                                    variant: SNACKBAR_VARIANT_SUCCESS,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                e = _state.sent();
                                console.error(e);
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                error = _state.sent();
                                fieldError = error.error_info.description;
                                startIndex = fieldError.indexOf("[");
                                endIndex = fieldError.indexOf("]");
                                key = fieldError.substring(startIndex + 1, endIndex);
                                if (fieldError) {
                                    isDeliveryAddressForm ? enqueueSnackbar(i18n.snackbar.deliveryAddressEditFail, {
                                        variant: SNACKBAR_VARIANT_ERROR,
                                        autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                    }) : enqueueSnackbar(i18n.snackbar.billingAddressEditFail, {
                                        variant: SNACKBAR_VARIANT_ERROR,
                                        autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                    });
                                }
                                if (key.length > 0) {
                                    errorKey = "".concat(key, "Error");
                                    _this.setState(_define_property({}, errorKey, _this.props.i18n.errors[key]));
                                } else {
                                    _this.setState({
                                        globalFormError: fieldError
                                    });
                                }
                                _this.props.setUserLoad(false);
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * Validates the inputs
   * @param key {string}
   * @returns {boolean}
   */ key: "validateInput",
            value: function validateInput(key) {
                var _this_props = this.props, i18n = _this_props.i18n, isDeliveryAddressForm = _this_props.isDeliveryAddressForm, sameAddress = _this_props.sameAddress;
                var value = this.state[key];
                var requiredFields = [
                    FIRST_NAME_INPUT,
                    LAST_NAME_INPUT,
                    PHONE_INPUT,
                    COUNTRY_DROPDOWN
                ];
                requiredFields = sameAddress || isDeliveryAddressForm ? _to_consumable_array(requiredFields).concat([
                    ZIP_INPUT,
                    ADDRESS_INPUT,
                    CITY_INPUT
                ]) : requiredFields;
                var error = "";
                if (requiredFields.find(function(el) {
                    return el === key;
                }) && value.replace(/\s/g, "").length <= 0) {
                    error = i18n.errors.requiredField;
                } else {
                    if (key === FIRST_NAME_INPUT || key === LAST_NAME_INPUT || key === CITY_INPUT) {
                        error = value.replace(/\s/g, "").match(REGEX_ALPHABET) ? i18n.errors.latinCharacters : "";
                    } else if (key === ZIP_INPUT) {
                        error = value.replace(/\s/g, "").match(REGEX_ALPHANUMERIC) ? i18n.errors.zip : "";
                    } else if (key === ADDRESS_INPUT) {
                        error = value.replace(/\s/g, "").match(REGEX_ADDRESS) ? i18n.errors.address : "";
                    } else if (key === PHONE_INPUT) {
                        error = value.replace(/\s/g, "").match(REGEX_PHONE) ? i18n.errors.phone : "";
                    }
                }
                this.setState(function() {
                    return _define_property({}, "".concat(key, "Error"), error);
                });
                return error.length <= 0;
            }
        },
        {
            /**
   * Validates the different checkboxes.
   * Uses their key to
   * identify the right checkbox.
   * @param key {string}
   */ key: "validateCheckbox",
            value: function validateCheckbox(key) {
                this.setState(function(prevState) {
                    return _define_property({}, "".concat(key, "Error"), prevState[key]);
                });
            }
        },
        {
            /**
   * Sets the new state for a given input.
   * @param event {Object}
   */ key: "changeInputValue",
            value: function changeInputValue(event) {
                var _this = this;
                var _event_target = event.target, checked = _event_target.checked, name = _event_target.name, type = _event_target.type, value = _event_target.value;
                var key = type === "checkbox" ? value : name;
                var newValue = type === "checkbox" ? checked : value;
                this.setState(_define_property({}, key, newValue), function() {
                    return _this.validateInput(name);
                });
            }
        },
        {
            /**
   * Sets the current country from the country dropdown and maps
   * it to the COUNTRIES constant so we can extract the country code
   * @param event {object}
   */ key: "changeCountry",
            value: function changeCountry(event) {
                var selectedCountry = COUNTRIES.filter(function(countryObj) {
                    return countryObj.name === event.target.value;
                });
                this.setState({
                    country: event.target.value,
                    countryCode: selectedCountry[0].code
                });
            }
        },
        {
            /**
   * Method responsible for rendering the different inputs
   * @param name {string}
   * @param additionalClasses {string}
   * @param isRequired {boolean}
   * @returns {ReactElement}
   */ key: "renderInput",
            value: function renderInput(name, additionalClasses, isRequired) {
                var _this = this;
                var inputValue = this.state[name];
                var error = this.state["".concat(name, "Error")];
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsx(TextField, {
                    id: name,
                    name: name,
                    value: inputValue,
                    type: "text",
                    required: isRequired,
                    onChange: this.changeInputValue,
                    onBlur: function() {
                        return _this.validateInput(name);
                    },
                    className: "ux-text-field-root ".concat(additionalClasses),
                    InputProps: {
                        className: "ux-input",
                        classes: {
                            error: "ux-input-error"
                        }
                    },
                    InputLabelProps: {
                        classes: {
                            root: "ux-input-label"
                        }
                    },
                    FormHelperTextProps: {
                        error: true,
                        classes: {
                            root: "ux-form-helper-text"
                        }
                    },
                    error: error !== "",
                    helperText: error,
                    label: i18n.account[name],
                    margin: "none"
                });
            }
        },
        {
            /**
   * Removes hover class from elements
   * @param elements {Array}
   */ key: "removeHoverClass",
            value: function removeHoverClass(elements) {
                Array.prototype.forEach.call(elements, function(element) {
                    if (element.classList.contains("hover")) {
                        element.classList.remove("hover");
                    }
                });
            }
        },
        {
            /**
   * Focuses the specified country name on keyboard typing
   * @param event {Object}
   */ key: "searchDropdown",
            value: function searchDropdown(event) {
                var _this = this;
                var key = event.which;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(function() {
                    _this.dropdownSearchQuery = "";
                }, DROPDOWN_KEYBOARD_SEARCH_TIMEOUT);
                var listItems = [];
                var countriesList = document.getElementById("menu-country");
                if (countriesList) {
                    listItems = countriesList.getElementsByTagName("li");
                }
                if (key === KEY_ARROW_UP || key === KEY_ARROW_DOWN) {
                    this.removeHoverClass(listItems);
                }
                var character = String.fromCharCode(key).toLowerCase();
                var isLetter = /[a-z]/i.test(character);
                if (isLetter) {
                    this.dropdownSearchQuery += character;
                    Array.prototype.some.call(listItems, function(listItem, index, listItems) {
                        var country = listItem.innerText.toLowerCase();
                        var nextCountry = listItems[_this.activeIndex + 1].innerHTML.toLowerCase();
                        var doesStartWithSearchQuery = country.substr(0, _this.dropdownSearchQuery.length) === _this.dropdownSearchQuery;
                        var doesNextCountryStartWithCharacter = nextCountry.substr(0, 1) === character;
                        var sameLetter = _this.dropdownSearchQuery.slice(0, -1) === character;
                        if (doesStartWithSearchQuery) {
                            _this.removeHoverClass(listItems);
                            listItem.focus();
                            listItem.classList.add("hover");
                            _this.activeIndex = index;
                            return true;
                        }
                        if (!doesStartWithSearchQuery && sameLetter && doesNextCountryStartWithCharacter && _this.dropdownSearchQuery.length === 2) {
                            _this.removeHoverClass(listItems);
                            listItems[_this.activeIndex + 1].focus();
                            listItems[_this.activeIndex + 1].classList.add("hover");
                            _this.activeIndex += 1;
                            _this.dropdownSearchQuery = _this.dropdownSearchQuery.slice(0, -1);
                            return true;
                        }
                    });
                }
            }
        },
        {
            /**
   * Renders the countries dropdown
   * @returns {ReactElement}
   */ key: "renderCountriesDropdown",
            value: function renderCountriesDropdown() {
                var _this = this;
                var shouldShowBulgaria = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var _this_state = this.state, country = _this_state.country, countryError = _this_state.countryError;
                var i18n = this.props.i18n;
                var countries = COUNTRIES.map(function(country) {
                    return /*#__PURE__*/ _jsx(MenuItem, {
                        value: country.name,
                        className: "ux-select-option",
                        classes: {
                            selected: "ux-select-option-selected"
                        },
                        children: country.name
                    }, country.code);
                });
                return /*#__PURE__*/ _jsx("div", {
                    id: "countries-dropdown",
                    ref: function(node) {
                        return _this.dropdown = node;
                    },
                    children: /*#__PURE__*/ _jsx(TextField, {
                        id: COUNTRY_DROPDOWN,
                        name: COUNTRY_DROPDOWN,
                        value: country,
                        select: true,
                        required: true,
                        onChange: function(event) {
                            return _this.changeCountry(event);
                        },
                        onBlur: function() {
                            return _this.validateInput(COUNTRY_DROPDOWN);
                        },
                        className: "ux-text-field-root countries-select",
                        InputProps: {
                            className: "ux-input",
                            classes: {
                                error: "ux-input-error"
                            }
                        },
                        InputLabelProps: {
                            classes: {
                                root: "ux-input-label"
                            }
                        },
                        error: countryError !== "",
                        helperText: countryError,
                        variant: "outlined",
                        label: i18n.account.country,
                        children: countries
                    })
                });
            }
        },
        {
            /**
   * Opens the gdpr popup.
   */ key: "openGdprPopup",
            value: function openGdprPopup() {
                this.props.openGdpr("invoice");
            }
        },
        {
            key: "setGdprButtonRef",
            value: function setGdprButtonRef(element) {
                var isDeliveryAddressForm = this.props.isDeliveryAddressForm;
                if (element) {
                    if (isDeliveryAddressForm) {
                        this.gdprShippingButton = element.children[0];
                    } else {
                        this.gdprBillingButton = element.children[0];
                    }
                }
            }
        },
        {
            /**
   * Renders gdpr checkbox for billing and shipping information
   * @returns {ReactElement}
   */ key: "renderGDPRCheckbox",
            value: function renderGDPRCheckbox() {
                var _this = this;
                var _this_props = this.props, i18n = _this_props.i18n, isDeliveryAddressForm = _this_props.isDeliveryAddressForm;
                var GDPR = !isDeliveryAddressForm ? GDPR_BILLING_CHECKBOX : GDPR_SHIPPING_CHECKBOX;
                var provideInfo = '<button type="button" class="gdpr-button translation-active">'.concat(i18n.account[GDPR], "</button>");
                var provideInfoLabel = /*#__PURE__*/ _jsx("span", {
                    ref: this.setGdprButtonRef,
                    dangerouslySetInnerHTML: {
                        __html: replaceWith(i18n.authentication.agreeTo, provideInfo)
                    }
                });
                return /*#__PURE__*/ _jsx(FormControlLabel, {
                    control: /*#__PURE__*/ _jsx(Checkbox, {
                        type: "checkbox",
                        value: GDPR,
                        checked: this.state[GDPR],
                        required: true,
                        onChange: this.changeInputValue,
                        onClick: function() {
                            return _this.validateCheckbox(GDPR);
                        },
                        classes: {
                            checked: "ux-checked"
                        }
                    }),
                    label: provideInfoLabel,
                    classes: {
                        root: "ux-checkbox-label-root",
                        label: "ux-checkbox-label tiny-font".concat(this.state["".concat(GDPR, "Error")] ? " error" : "")
                    }
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, i18n = _this_props.i18n, isDeliveryAddressForm = _this_props.isDeliveryAddressForm, classes = _this_props.classes, title = _this_props.title, subTitle = _this_props.subTitle, shouldToggleWithTransition = _this_props.shouldToggleWithTransition, order = _this_props.order, sameAddress = _this_props.sameAddress, renderSameAddressCheckbox = _this_props.renderSameAddressCheckbox;
                var _this_state = this.state, isComponentMounted = _this_state.isComponentMounted, globalFormError = _this_state.globalFormError;
                var wrapperClasses = classes;
                wrapperClasses = isComponentMounted && shouldToggleWithTransition ? "".concat(wrapperClasses, " mounted") : wrapperClasses;
                wrapperClasses = shouldToggleWithTransition ? wrapperClasses : "".concat(wrapperClasses, " no-animation");
                return /*#__PURE__*/ _jsxs("div", {
                    onKeyDown: function(event) {
                        return _this.searchDropdown(event);
                    },
                    className: "edit-information-wrapper paper-card light ".concat(wrapperClasses).concat(order ? "" : " small"),
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "head",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "main-title-wrapper",
                                    children: [
                                        isDeliveryAddressForm ? /*#__PURE__*/ _jsx("span", {
                                            className: "icon icon-local-shipping"
                                        }) : /*#__PURE__*/ _jsx("span", {
                                            className: "icon icon-location"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text",
                                            children: title
                                        })
                                    ]
                                }),
                                subTitle.length > 0 ? /*#__PURE__*/ _jsx("div", {
                                    className: "sub-text",
                                    children: subTitle
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "details",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "hint",
                                    children: [
                                        "*",
                                        i18n.account.markedInputsRequired
                                    ]
                                }),
                                this.renderInput(FIRST_NAME_INPUT, "left", true),
                                this.renderInput(LAST_NAME_INPUT, "right", true),
                                this.renderCountriesDropdown(isDeliveryAddressForm),
                                this.renderInput(PHONE_INPUT, "", true),
                                this.renderInput(CITY_INPUT, "left", !!(sameAddress || isDeliveryAddressForm)),
                                this.renderInput(ZIP_INPUT, "right", !!(sameAddress || isDeliveryAddressForm)),
                                this.renderInput(ADDRESS_INPUT, "", !!(sameAddress || isDeliveryAddressForm)),
                                this.renderGDPRCheckbox(),
                                renderSameAddressCheckbox(isDeliveryAddressForm, false)
                            ]
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "common-error",
                            children: globalFormError
                        })
                    ]
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                var _this_gdprBillingButton, _this_gdprShippingButton;
                this._isMounted = true;
                this.animationTimeout = setTimeout(function() {
                    if (_this._isMounted) {
                        _this.setState({
                            isComponentMounted: true
                        });
                    }
                }, ANIMATION_TIMEOUT);
                (_this_gdprBillingButton = this.gdprBillingButton) === null || _this_gdprBillingButton === void 0 ? void 0 : _this_gdprBillingButton.addEventListener("click", this.openGdprPopup);
                (_this_gdprShippingButton = this.gdprShippingButton) === null || _this_gdprShippingButton === void 0 ? void 0 : _this_gdprShippingButton.addEventListener("click", this.openGdprPopup);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this_gdprBillingButton, _this_gdprShippingButton;
                this._isMounted = false;
                clearTimeout(this.timeout);
                clearTimeout(this.animationTimeout);
                (_this_gdprBillingButton = this.gdprBillingButton) === null || _this_gdprBillingButton === void 0 ? void 0 : _this_gdprBillingButton.removeEventListener("click", this.openGdprPopup);
                (_this_gdprShippingButton = this.gdprShippingButton) === null || _this_gdprShippingButton === void 0 ? void 0 : _this_gdprShippingButton.removeEventListener("click", this.openGdprPopup);
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if (nextProps.willComponentUnmount) {
                    this.setState(function() {
                        return {
                            isComponentMounted: false
                        };
                    });
                }
                if (nextProps.validateForms) {
                    this.validateForm();
                }
                if (nextProps.shouldSubmitForm) {
                    this.submitForm();
                    this.props.allowFormSubmit(false);
                }
            }
        }
    ]);
    return EditUserAddress;
}(PureComponent);
var mapStateToProps = function(param) {
    var authentication = param.authentication, userDetails = param.userDetails;
    return {
        authentication: authentication,
        userDetails: userDetails
    };
};
export default withSnackbar(connect(mapStateToProps, {
    editBillingDetails: editBillingDetails,
    getFullUserDetails: getFullUserDetails,
    openGdpr: openGdpr
})(EditUserAddress));
